import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateInvoicePDF = (invoice, load, carrier) => {
    const doc = new jsPDF();
    
    // Colors
    const primaryColor = [249, 115, 22]; // Orange
    const darkColor = [39, 39, 42]; // Zinc-800
    const textColor = [250, 250, 250]; // White
    const mutedColor = [161, 161, 170]; // Zinc-400
    
    // Header background
    doc.setFillColor(...darkColor);
    doc.rect(0, 0, 220, 45, 'F');
    
    // Company Logo/Name
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    doc.text('LoadTMS', 20, 25);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...mutedColor);
    doc.text('DISPATCH COMMAND CENTER', 20, 32);
    
    // Invoice Title
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('INVOICE', 150, 25);
    
    doc.setFontSize(10);
    doc.setTextColor(...mutedColor);
    doc.text(`#${invoice.invoice_id}`, 150, 32);
    
    // Reset text color for body
    doc.setTextColor(0, 0, 0);
    
    // Invoice Details Section
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice Details', 20, 55);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    
    const invoiceDetails = [
        ['Invoice ID:', invoice.invoice_id],
        ['Date Issued:', new Date().toLocaleDateString()],
        ['Due Date:', invoice.due_date],
        ['Status:', invoice.status?.toUpperCase() || 'PENDING'],
    ];
    
    let yPos = 62;
    invoiceDetails.forEach(([label, value]) => {
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(100, 100, 100);
        doc.text(label, 20, yPos);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.text(value, 55, yPos);
        yPos += 6;
    });
    
    // Load Details Section
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Load Information', 110, 55);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    
    const loadDetails = [
        ['Load ID:', load?.load_id || invoice.load_id],
        ['Origin:', load ? `${load.origin_city}, ${load.origin_state}` : 'N/A'],
        ['Destination:', load ? `${load.destination_city}, ${load.destination_state}` : 'N/A'],
        ['Equipment:', load?.equipment_type || 'N/A'],
    ];
    
    yPos = 62;
    loadDetails.forEach(([label, value]) => {
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(100, 100, 100);
        doc.text(label, 110, yPos);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.text(value, 145, yPos);
        yPos += 6;
    });
    
    // Divider
    doc.setDrawColor(200, 200, 200);
    doc.line(20, 95, 190, 95);
    
    // Charges Table
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Charges', 20, 105);
    
    const tableData = [
        ['Freight Charges', load?.distance ? `${load.distance} miles` : '-', `$${invoice.amount?.toLocaleString() || '0'}`],
    ];
    
    if (load?.rate_per_mile) {
        tableData[0][1] = `${load.distance} mi @ $${load.rate_per_mile}/mi`;
    }
    
    autoTable(doc, {
        startY: 110,
        head: [['Description', 'Details', 'Amount']],
        body: tableData,
        theme: 'striped',
        headStyles: {
            fillColor: darkColor,
            textColor: textColor,
            fontStyle: 'bold',
        },
        styles: {
            fontSize: 9,
        },
        columnStyles: {
            0: { cellWidth: 80 },
            1: { cellWidth: 60 },
            2: { cellWidth: 40, halign: 'right' },
        },
    });
    
    // Total
    const finalY = doc.lastAutoTable.finalY + 10;
    
    doc.setFillColor(245, 245, 245);
    doc.rect(110, finalY - 5, 80, 20, 'F');
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('Total Due:', 115, finalY + 5);
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    doc.text(`$${invoice.amount?.toLocaleString() || '0'}`, 185, finalY + 5, { align: 'right' });
    
    // Payment Instructions
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Payment Instructions', 20, finalY + 30);
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('Please remit payment within 30 days of invoice date.', 20, finalY + 38);
    doc.text('For questions regarding this invoice, please contact your dispatcher.', 20, finalY + 45);
    
    // Notes
    if (invoice.notes) {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.text('Notes', 20, finalY + 60);
        
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(100, 100, 100);
        doc.text(invoice.notes, 20, finalY + 68);
    }
    
    // Footer
    doc.setFillColor(...darkColor);
    doc.rect(0, 280, 220, 20, 'F');
    
    doc.setFontSize(8);
    doc.setTextColor(...mutedColor);
    doc.text('Generated by LoadTMS | Dispatch Command Center', 105, 290, { align: 'center' });
    
    // Save the PDF
    doc.save(`Invoice_${invoice.invoice_id}.pdf`);
};

export const generateBOLPDF = (load) => {
    const doc = new jsPDF();
    
    const primaryColor = [249, 115, 22];
    const darkColor = [39, 39, 42];
    const textColor = [250, 250, 250];
    const mutedColor = [161, 161, 170];
    
    // Header
    doc.setFillColor(...darkColor);
    doc.rect(0, 0, 220, 45, 'F');
    
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    doc.text('LoadTMS', 20, 25);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...mutedColor);
    doc.text('DISPATCH COMMAND CENTER', 20, 32);
    
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('BILL OF LADING', 140, 25);
    
    doc.setFontSize(10);
    doc.setTextColor(...mutedColor);
    doc.text(`Load: ${load.load_id}`, 140, 32);
    
    // Reset colors
    doc.setTextColor(0, 0, 0);
    
    // Shipment Info Box
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('SHIPMENT INFORMATION', 20, 55);
    
    doc.setDrawColor(200, 200, 200);
    doc.rect(20, 60, 170, 40);
    
    // Origin
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(34, 197, 94); // Green
    doc.text('ORIGIN', 25, 70);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(11);
    doc.text(`${load.origin_city}, ${load.origin_state}`, 25, 78);
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(`Pickup: ${load.pickup_date}`, 25, 85);
    
    // Arrow
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.text('→', 100, 78);
    
    // Destination
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(239, 68, 68); // Red
    doc.text('DESTINATION', 115, 70);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(11);
    doc.text(`${load.destination_city}, ${load.destination_state}`, 115, 78);
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(`Delivery: ${load.delivery_date || 'TBD'}`, 115, 85);
    
    // Load Details Table
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('LOAD DETAILS', 20, 115);
    
    const loadData = [
        ['Load ID', load.load_id],
        ['Equipment Type', load.equipment_type],
        ['Weight', load.weight ? `${load.weight.toLocaleString()} lbs` : 'N/A'],
        ['Distance', load.distance ? `${load.distance.toLocaleString()} miles` : 'N/A'],
        ['Rate', load.rate ? `$${load.rate.toLocaleString()}` : 'N/A'],
        ['Status', load.status?.toUpperCase() || 'PENDING'],
    ];
    
    autoTable(doc, {
        startY: 120,
        body: loadData,
        theme: 'plain',
        styles: {
            fontSize: 10,
            cellPadding: 4,
        },
        columnStyles: {
            0: { fontStyle: 'bold', textColor: [100, 100, 100], cellWidth: 50 },
            1: { cellWidth: 80 },
        },
    });
    
    // Carrier Info
    const finalY = doc.lastAutoTable.finalY + 15;
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('CARRIER INFORMATION', 20, finalY);
    
    doc.setDrawColor(200, 200, 200);
    doc.rect(20, finalY + 5, 170, 30);
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('Carrier ID:', 25, finalY + 15);
    doc.text('Driver:', 25, finalY + 23);
    
    doc.setTextColor(0, 0, 0);
    doc.text(load.carrier_id || 'Not Assigned', 55, finalY + 15);
    doc.text(load.driver_id || 'Not Assigned', 55, finalY + 23);
    
    // Signature Lines
    const sigY = finalY + 55;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('SIGNATURES', 20, sigY);
    
    doc.setDrawColor(0, 0, 0);
    doc.line(20, sigY + 20, 90, sigY + 20);
    doc.line(110, sigY + 20, 180, sigY + 20);
    
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text('Shipper Signature / Date', 20, sigY + 25);
    doc.text('Carrier Signature / Date', 110, sigY + 25);
    
    // Footer
    doc.setFillColor(...darkColor);
    doc.rect(0, 280, 220, 20, 'F');
    
    doc.setFontSize(8);
    doc.setTextColor(...mutedColor);
    doc.text('Generated by LoadTMS | Dispatch Command Center', 105, 290, { align: 'center' });
    
    doc.save(`BOL_${load.load_id}.pdf`);
};
